package com.schoolconnect.app.repository.common

import com.schoolconnect.app.repository.academicyear.AcademicYearRepository
import com.schoolconnect.app.repository.analytics.SchoolAnalyticsRepository
import com.schoolconnect.app.repository.analytics.SchoolStatisticsRepository
import com.schoolconnect.app.repository.classsection.ClassSectionRepository
import com.schoolconnect.app.repository.classsubjectlink.ClassSubjectLinkRepository
import com.schoolconnect.app.repository.home.HomeDashboardRepository
import com.schoolconnect.app.repository.itusers.ITUsersRepository
import com.schoolconnect.app.repository.parent.ParentRepository
import com.schoolconnect.app.repository.school.SchoolRepository
import com.schoolconnect.app.repository.schoolstaff.SchoolStaffRepository
import com.schoolconnect.app.repository.schoolusers.SchoolUsersRepository
import com.schoolconnect.app.repository.student.StudentRepository
import com.schoolconnect.app.repository.subject.SubjectRepository
import com.schoolconnect.app.repository.user.UserRepository
import com.schoolconnect.app.util.scLog

/**
 * Clears in-memory data that can be reused after a role, school, account, or
 * assignment context changes. This is intentionally conservative until every
 * repository has an explicit context-keyed cache contract.
 */
object TenantContextCacheCoordinator {
    private const val TAG = "[DATA_RETRIEVE_SC] TenantContextCacheCoordinator"

    fun invalidateAll(reason: String) {
        scLog("$TAG invalidateAll reason=${reason.trim().ifBlank { "context-change" }}")
        UserRepository.invalidateCache()
        HomeDashboardRepository.invalidateAll()
        SchoolStatisticsRepository.invalidateAll()
        SchoolAnalyticsRepository.invalidateAll()
        SchoolRepository.invalidateCaches()
        SchoolUsersRepository.invalidateCaches()
        SchoolStaffRepository.invalidateCaches()
        StudentRepository.invalidateCaches()
        ParentRepository.invalidateCache()
        SubjectRepository.invalidateCaches()
        ClassSectionRepository.invalidateCaches()
        ClassSubjectLinkRepository.invalidateCaches()
        AcademicYearRepository.invalidateCaches()
        ITUsersRepository.invalidateCaches()
    }
}
